<mojo-widget [title]="widget.title" [showWidgetControls]="true" [widget]="widget">
  <ng-container widget-body>
    <mojo-detail-items-body [data]="data"></mojo-detail-items-body>
  </ng-container>
</mojo-widget>
